module.exports = window["Bernie_l10nBundle_zh_HK"];